// Several Mac windows streaming at once (docs/features/one-scene.md, "Several streams"): only the streams being looked
// at run at their chosen rate; the others trickle at one frame a second and catch up with a keyframe when they come
// into view (Josh, 09-27: "only stream windows being looked at and update when looked at"). In Snap that is the window
// in front (a stream in a pane goes with its session window); in Look and VR, whatever is in view — the world says
// (`inView`, core/render-dom.js). The player sends the rate (windows/macwindow/player.js `options()`: 1 fps while not
// attentive). app.js calls this every 1.5 s and whenever a window comes to the front.
//
// One seam: `applyAttention(streams, inView, wantedFPS)` → the streams whose attention changed; `MAX_STREAMS`.

/// At most this many windows stream at once: each has its own data channel and its own encoder on the Mac.
export const MAX_STREAMS = 6

export function applyAttention(streams, inView, wantedFPS) {
  const changed = []
  for (const spec of streams) {
    const seen = !!inView(spec)
    if (spec.attentive === seen) continue
    spec.attentive = seen
    if (spec.player) spec.player.sendOptions(); else spec.stream.options({ maxFPS: seen ? wantedFPS() : 1 })
    if (seen) spec.stream.keyframe()
    changed.push(spec)
  }
  return changed
}
